import { useState, useRef, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import queryString from 'query-string';
import { useForm } from 'react-hook-form';
import {
  FormGroup,
  FormLabel,
  Grid,
  CircularProgress,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  InputAdornment,
  IconButton,
  useTheme,
  Box,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CustomTextField, CustomButton } from 'components/common';
import { ApiPostNoAuth } from 'helpers/Api/ApiData';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import signinImg from 'assets/images/signin-img.svg';
import Link from 'components/Link';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useRouter } from 'next/router';

interface EmailSignupProps {
  /**
   * handle back button click
   */
  handleBack: () => void;
  setResisterSuccess: (_arg0: any) => void;
}

const EmailSignup = ({ handleBack, setResisterSuccess }: EmailSignupProps) => {
  const theme = useTheme();
  const useStyles = makeStyles({
    loginSignUpWrap: {
      // minHeight: "calc(100vh - 90px)",
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      '& MuiGrid-item': {
        widhandleBackth: '100%',
      },
      // [theme.breakpoints.down('sm')]:{
      //     minHeight: "calc(100vh - 256px)",
      // }
    },
    loginSignUpBox: {
      height: '100%',
      backgroundColor: '#fff',
      padding: '30px 30px',
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'flex-start',
      // padding: "0px 22% 50px",
      borderRadius: 0,
      '& .MuiSvgIcon-root': {
        cursor: 'pointer',
      },
      // [theme.breakpoints.down('lg')]: {
      //     padding: "0px 15% 50px",
      // },
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },

      // [theme.breakpoints.down('xs')]: {
      //     padding: "50px 10% 50px",
      // },

      '& h2': {
        marginBottom: 20,
        fontWeight: 500,
        fontSize: 20,
        lineHeight: 1,
        color: '#111111',
      },

      '& .MuiFormGroup-root': {
        // marginBottom: 20,
      },

      // '& .MuiFormLabel-root': {
      //   fontSize: 14,
      //   color: '#111111',
      //   lineHeight: 1.2,
      //   padding: 0,
      // },
      // '& .MuiInputLabel-outlined': {
      //   transform: 'translate(15px, 12px) scale(1)',
      //   [theme.breakpoints.down('xs')]: {
      //     transform: 'translate(15px, 15px) scale(1)',
      //   },
      // },
      // '& .MuiInputLabel-shrink': {
      //   transform: 'translate(15px, -8px) scale(1)',
      //   backgroundColor: '#fff',
      //   fontSize: 12,
      //   padding: '0 11px',
      //   color: 'rgba(17, 17, 17, 0.5)',
      // },
      // '& .MuiInputBase-formControl': {
      //   '& .MuiOutlinedInput-input': {
      //     padding: '12px 15px',
      //     fontSize: 14,
      //     [theme.breakpoints.down('xs')]: {
      //       fontSize: 14,
      //       padding: '15px 15px',
      //     },
      //   },
      // },
      '& .MuiButton-root': {
        width: '250px',
        borderRadius: 40,
        margin: '0px auto',

        '& span': {
          fontSize: 20,
          lineHeight: 1,
        },
      },
    },
    loginSignImg: {
      height: 'calc(100%)',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(252, 252, 252, 0.5)',
      paddingTop: '90px',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    loginSignImg1: {
      height: 'calc(100vh)',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(252, 252, 252, 0.5)',
      paddingTop: '175px',

      '& img': {
        width: '60%',
        display: 'noone',
        margin: '0 auto 100px',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },

    loginSignImg2: {
      paddingTop: '100px',
      '& img': {
        width: '50%',
        display: 'none',
        margin: '0 auto 50px',
        [theme.breakpoints.down('md')]: {
          display: 'none',
        },
      },
    },
    forgotLink: {
      cursor: 'pointer',
      display: 'block',
      fontSize: 14,
      color: 'rgba(17, 17, 17, 0.7)',
      lineHeight: '19px',
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
      '&:hover': {
        color: 'rgba(17, 17, 17, 1)',
      },
    },
    newRegister: {
      textAlign: 'center',
      fontSize: 14,
      color: '#111',
      fontWeight: 400,
      marginTop: 10,
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
      '& a': {
        color: '#008b5e',
        fontWeight: 700,
      },
    },
    error: {
      fontSize: 12,
      lineHeight: 1,
      display: 'flex',
      // flexWrap: 'wrap',
      marginTop: 5,

      '& svg': {
        fontSize: 14,
        verticalAlign: 'middle',
        marginRight: 4,
      },
      '& .MuiInputBase-formControl': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#DD6161',
        },
      },
    },
    radioWant: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 15,
      alignItems: 'center',

      '& .MuiFormLabel-root': {
        width: 100,
      },

      '& .MuiFormGroup-row': {
        marginBottom: 0,
        width: 'calc(100% - 100px)',
        [theme.breakpoints.down('sm')]: {
          width: 'calc(100% - 30px)',
        },
      },

      '& .MuiFormControlLabel-root': {
        marginRight: 40,
        [theme.breakpoints.down('xs')]: {
          marginRight: 30,
        },
      },

      '& .MuiFormControlLabel-label': {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 16,
        },
      },

      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    SignUpWelcome: {
      height: '100%',
      backgroundColor: '#fff',
      padding: '45px 25% 0',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',

      [theme.breakpoints.down('sm')]: {
        padding: '0px 15% 0',
      },
      [theme.breakpoints.down('xs')]: {
        padding: '0 10%',
      },
    },
    SignUpWelcomeContent: {
      display: 'flex',
      flexWrap: 'wrap',

      '& h2': {
        width: '100%',
        display: 'block',
        fontWeight: 500,
        fontSize: 28,
        lineHeight: 1,
        color: '#111111',
        textAlign: 'center',
        margin: '54px 0 18px 0',
        [theme.breakpoints.down('xs')]: {
          marginTop: '50px',
        },
      },
      '& p': {
        display: 'block',
        fontWeight: 400,
        fontSize: 20,
        lineHeight: '28px',
        color: '#111111',
        textAlign: 'center',
      },
      '& span': {
        fontSize: '12px',
        textAlign: 'center',
        marginTop: '20px',
        lineHeight: '16px',
        padding: '10px 20px',
        color: 'rgba(17, 17, 17,0.5)',
      },
    },
    loginSignUpForm: {
      display: 'flex',
      width: '100%',
      maxWidth: 524,
      // margin: '0 auto',
      '& .MuiSvgIcon-root': {
        cursor: 'pointer',
      },
      '& form': {
        width: '100%',
        display: 'block',
      },
    },

    ReferralCode: {
      '& .MuiInputBase-root': {
        '& input': {
          textTransform: 'uppercase',
          '&:disabled': {
            color: 'rgba(17, 17, 17,0.5)',
          },
        },
      },
    },
    passwordIcon: {
      verticalAlign: 'middle',
      marginRight: 4,
      '& svg': {
        fontSize: '1.5rem',
      },
    },
    firstNameTExtField: {
      '& .MuiFormControl-root': {
        marginBottom: '0px',
      },
      '& MuiBox-root': {
        marginTop: '0px',
      },
      [theme.breakpoints.down('xs')]: {
        marginBottom: '-4px !important',
      },
    },

    //Gmail Account
    gmailAccountWrap: {
      // minHeight: "calc(100vh - 90px)",
      display: 'flex',
      justifyContent: 'center',
      flex: 1,
      '& MuiGrid-iteerrorm': {
        width: '100%',
      },
    },
    gmailSignImg: {
      height: 'calc(100%)',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(252, 252, 252, 0.5)',
      paddingTop: '90px',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    signUpGmailBox: {
      height: '100%',
      backgroundColor: '#fff',
      padding: '49px 30px',
      // padding: "0px 22% 50px",
      borderRadius: 0,
      display: 'flex',
      alignItems: 'flex-start',
      //flexDirection: "column",
      [theme.breakpoints.down(767)]: {
        padding: '49px 15px',
        flexDirection: 'column',
      },
      '& .MuiSvgIcon-root': {
        cursor: 'pointer',
      },
      backIcon: {
        marginRight: '10px',
      },
      '& h2': {
        marginBottom: 20,
        fontWeight: 500,
        fontSize: 20,
        lineHeight: 1,
        color: '#111111',
      },
      '& .MuiButton-root': {
        width: '250px',
        borderRadius: 40,
        margin: '0px auto',

        '& span': {
          fontSize: 20,
          lineHeight: 1,
        },
      },
    },
    '& .MuiFormGroup-root': {
      marginBottom: 20,
    },

    '& .MuiFormLabel-root': {
      fontSize: 14,
      color: '#111111',
      lineHeight: 1.2,
      padding: 0,
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(15px, 12px) scale(1)',
      [theme.breakpoints.down('xs')]: {
        transform: 'translate(15px, 15px) scale(1)',
      },
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(15px, -8px) scale(1)',
      backgroundColor: '#fff',
      fontSize: 12,
      padding: '0 11px',
      color: 'rgba(17, 17, 17, 0.5)',
    },
    '& .MuiInputBase-formControl': {
      '& .MuiOutlinedInput-input': {
        padding: '12px 15px',
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 14,
          padding: '15px 15px',
        },
      },
    },
    signUpGmailForm: {
      display: 'block',
      width: '100%',
      maxWidth: 524,
      margin: '0 auto',
      heading: {
        display: 'flex',
      },
    },
    gmailRadioWant: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 15,
      alignItems: 'center',

      '& .MuiFormLabel-root': {
        color: '#111111',
        width: 100,
        fontSize: 14,
      },

      '& .MuiFormGroup-row': {
        marginBottom: 0,
        [theme.breakpoints.down(767)]: {
          width: '100%',
        },
      },

      '& .MuiFormControlLabel-root': {
        marginRight: 40,
        [theme.breakpoints.down('xs')]: {
          marginRight: 30,
        },
      },

      '& .MuiFormControlLabel-label': {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 14,
        },
      },

      [theme.breakpoints.down(767)]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    mobileTextField: {
      marginBottom: '25px',
      '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 16px) scale(1)',
        fontSize: '14px',
      },
      '& .MuiInputBase-input': {
        padding: '12px 15px',
        fontSize: '14px',
      },
    },
    referrerTextField: {
      marginBottom: '51px',
      '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 16px) scale(1)',
        fontSize: '14px',
      },
      '& .MuiInputBase-input': {
        padding: '12px 15px',
        fontSize: '14px',
      },
    },
    gmailSignupButton: {
      alignItems: 'center',
      marginBottom: '27px',
      '& span': {
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: 'bold',
      },
    },
    gmailNewRegister: {
      textAlign: 'center',
      fontSize: 14,
      color: '#111111',
      fontWeight: 400,
      //	marginTop: '40px',
      //	marginLeft: '35px',
      fontStyle: 'normal',
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
      '& a': {
        color: '#008b5e',
        fontWeight: 700,
      },
    },

    //Two Button Account
    signUpAccountWrap: {
      //minHeight: "calc(100vh - 90px)",
      display: 'flex',
      justifyContent: 'center',
      flex: 1,
      '& MuiGrid-item': {
        width: '100%',
      },
    },
    signUpAccountBox: {
      height: '100%',
      backgroundColor: '#fff',
      padding: '30px',
      // padding: "0px 22% 50px",
      borderRadius: 0,
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      justifyContent: 'center',
      textAlign: 'center',
      '& h2': {
        margin: '0 auto 20px',
        fontWeight: 500,
        fontSize: 28,
        lineHeight: 1,
        color: '#111111',
        [theme.breakpoints.down(767)]: {
          fontSize: '22px !important',
        },
      },
      '& .MuiButton-root': {
        // maxWidth: "280px",
        width: '100%',
        borderRadius: 40,
        // margin: '0px auto',

        '& span': {
          fontSize: 20,
          lineHeight: 1,
          [theme.breakpoints.down(360)]: {
            fontSize: 18,
          },
        },
      },
    },
    signUpAccountForm: {
      width: '100%',
      // maxWidth: 531,
      margin: '0 auto',
      '& h2': {
        fontSize: 24,
        fontStyle: 'normal',
        fontWeight: 500,
        textAlign: 'center',
        color: '#111111',
      },
    },
    signupAccountButton: {
      margin: '0px auto 0',

      '& button:first-child': {
        marginBottom: '17px',
        maxWidth: '250px',
        border: '1px solid transparent',
        '& span': {
          justifyContent: 'flex-start',
        },
      },
      '& button:last-child': {
        // minHeight: "64px",
        maxWidth: '250px',
        marginBottom: '32px',
      },
      '& small': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        backgroundColor: '#fff',
        width: '40px',
        height: '40px',
        marginRight: '8px',
        padding: '5px',
      },
    },

    newRegisterAccount: {
      textAlign: 'center',
      fontSize: 14,
      color: '#111',
      fontWeight: 400,
      margin: '0 auto',
      fontStyle: 'normal',
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
      '& a': {
        color: '#008b5e',
        fontWeight: 700,
      },
    },
  });
  const router = useRouter();
  const queryReferralCode = router.query.referral_code as string | undefined;
  const queryUserType = router.query.userType as '2' | undefined;
  // console.log(router);
  // console.log(router.query);
  // console.log(router.asPath.match(new RegExp(`[&?]${`userType`}=(.*)(&|$)`)));
  const [role_id, setRole_id] = useState<'1' | '2'>('1');
  const [loader, setLoader] = useState(false);
  // const [resisterSuccess, setResisterSuccess] = useState<any>();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [repeatPasswordVisible, setRepeatPasswordVisible] = useState(false);
  const [isReady, setIsReady] = useState<boolean>(false);

  const password = useRef<HTMLInputElement>(null);

  // const validateName = (name: string) => {
  //   const regex = /^[A-Za-z]+\s*$/i;
  //   if (!regex.test(name)) {
  //     return 'Invalid input';
  //   } else if (name.trim().length < 3) {
  //     return 'Please enter at least 3 characters';
  //   }
  // };
  useEffect(() => {
    const queryStringValue = window.location.search;
    const queryObject = queryString.parse(queryStringValue);
    if (queryObject?.userType == '2') {
      setRole_id('2');
    }
    setIsReady(true);
  }, []);
  // useEffect(() => {
  //   debugger;
  //   console.log(router.query);
  //   if (queryUserType) {
  //     debugger;
  //     setRole_id(queryUserType);
  //   }
  // }, [queryUserType, router.query, router.isReady]);

  interface FormFields {
    first_name: string;
    last_name: string;
    email: string;
    phone_no: string;
    referrer_code: string;
    role_id: '1' | '2';
    password: string;
    confirm_password: string;
    age: number;
  }

  const schema = yup.object().shape({
    first_name: yup
      .string()
      .trim()
      .min(3, 'Please enter at least 3 characters')
      .required('First name is required')
      .matches(/^([A-Za-z]){2}[A-Za-z]+\s*$/i, 'Invalid input'),
    last_name: yup
      .string()
      .trim()
      .min(3, 'Please enter at least 3 characters')
      .matches(/^[A-Za-z]+\s*$/i, 'Invalid input')
      .required('Last name is required'),
    email: yup
      .string()
      .email('Please enter valid email address')
      .required('Email is required'),
    phone_no: yup
      .string()
      .matches(/^[0-9]{10}$/, 'Enter valid 10 digit mobile number')
      .required('Mobile no is required'),
    referrer_code: yup
      .string()
      .notRequired()
      .matches(/^(POD|pod)[a-zA-Z0-9]{7}\s*$/, {
        message: 'Invalid referral code',
        excludeEmptyString: true,
      }),
    password: yup
      .string()
      .min(
        8,
        'Minimum eight characters, at least one letter, one number and one special character',
      )
      .required('Password is required')
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i,
        'Minimum eight characters, at least one letter, one number and one special character',
      ),
    confirm_password: yup
      .string()
      .test(
        'check_passwords_match',
        `The passwords do not match`,
        (value) => value === password.current?.value,
      )
      .required('Confirm password is required'),
  });

  const classes = useStyles();
  const {
    control,
    handleSubmit,
    // formState: { errors },
  } = useForm<FormFields>({
    resolver: yupResolver(schema),
    defaultValues: {
      referrer_code: queryReferralCode || '',
    },
    // defaultValues: {},
    mode: 'onTouched',
  });
  const onSubmit = async (data: any) => {
    setLoader(true);
    data = {
      ...data,
      first_name: data.first_name.trim(),
      last_name: data.last_name.trim(),
      role_id: parseInt(role_id),
      referrer_code: data?.referrer_code?.toUpperCase().trim(),
    };
    console.log('data', data);
    ApiPostNoAuth(
      `${
        `user/signup`
        // redirectUrl
        //   ? `user/signup?redirect_url=${encodeURIComponent(redirectUrl)}`
        //   : `user/signup`
      }`,
      { ...data },
    )
      .then((res: any) => {
        if (res.data.statusCode === 200) {
          setResisterSuccess(res.data.data);
          setLoader(false);
        } else {
          toast.error(res.data.message, {
            autoClose: 5000,
            hideProgressBar: true,
          });
          setLoader(false);
        }
      })
      .catch((err: any) => {
        toast.error(err.message, { autoClose: 5000, hideProgressBar: true });
        setLoader(false);
      });
  };

  if (!isReady) {
    return null;
  }

  return (
    <Grid container>
      <ToastContainer />
      <Grid item xs={12} sm={12} md={6}>
        <div className={classes.loginSignImg}>
          <img src={signinImg.src} alt="signInImage" />
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <div className={classes.loginSignUpBox}>
          <Box pr={2}>
            <ArrowBackIcon
              sx={{ position: 'relative', top: 5 }}
              onClick={() => handleBack()}
            />
          </Box>
          <div className={classes.loginSignUpForm}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <h2>Sign up to create an account </h2>
              <Grid container columnSpacing={3}>
                <Grid item md={6} sm={6} xs={12}>
                  <FormGroup className={classes.firstNameTExtField}>
                    <CustomTextField
                      defaultValue=""
                      fullWidth
                      name="first_name"
                      type="text"
                      label="First Name"
                      variant="outlined"
                      autoComplete="given_name"
                      control={control}
                    />
                  </FormGroup>
                </Grid>
                <Grid item md={6} sm={6} xs={12}>
                  <FormGroup>
                    <CustomTextField
                      defaultValue=""
                      fullWidth
                      name="last_name"
                      type="text"
                      label="Last Name"
                      variant="outlined"
                      autoComplete="false"
                      control={control}
                    />
                  </FormGroup>
                </Grid>
              </Grid>
              <FormGroup>
                <CustomTextField
                  control={control}
                  name="email"
                  label="Email"
                  fullWidth
                  autoComplete="email"
                />
              </FormGroup>
              <FormGroup>
                <CustomTextField
                  control={control}
                  variant="outlined"
                  name="phone_no"
                  fullWidth
                  inputProps={{ maxLength: 10 }}
                  label="Mobile Number"
                />
              </FormGroup>
              <FormControl component="div" className={classes.radioWant}>
                <FormLabel component="legend">I want to</FormLabel>
                <RadioGroup
                  row
                  name="role_id"
                  defaultValue={role_id}
                  value={role_id}
                  onChange={(e) => setRole_id(e.target.value as '1' | '2')}
                >
                  <FormControlLabel
                    value="1"
                    control={<Radio color="primary" />}
                    label="Invest"
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio color="primary" />}
                    label="Raise Funds"
                  />
                </RadioGroup>
              </FormControl>
              {role_id === '1' ? (
                <FormGroup>
                  <CustomTextField
                    control={control}
                    variant="outlined"
                    name="referrer_code"
                    fullWidth
                    label="Enter the Referral code (optional)"
                  />
                </FormGroup>
              ) : null}
              <FormGroup>
                <CustomTextField
                  defaultValue=""
                  fullWidth
                  name="password"
                  type={passwordVisible ? 'text' : 'password'}
                  label="Password"
                  variant="outlined"
                  inputRef={password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          className={classes.passwordIcon}
                          aria-label="toggle password visibility"
                          onClick={() => setPasswordVisible(!passwordVisible)}
                        >
                          {passwordVisible ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  autoComplete="false"
                  control={control}
                />
              </FormGroup>
              <FormGroup>
                <CustomTextField
                  defaultValue=""
                  fullWidth
                  type={repeatPasswordVisible ? 'text' : 'password'}
                  name="confirm_password"
                  label="Confirm Password"
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          className={classes.passwordIcon}
                          aria-label="toggle password visibility"
                          onClick={() =>
                            setRepeatPasswordVisible(!repeatPasswordVisible)
                          }
                        >
                          {repeatPasswordVisible ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  autoComplete="false"
                  control={control}
                />
              </FormGroup>
              <FormGroup sx={{ mt: 1, width: '100%' }}>
                {/* {loader ? (
                  <CustomButton
                  // bgColor="#008b5e"
                  // bordercolor="#008b5e"
                  // fontColor="#ffffff"
                  // radius="0"
                  // btnPadding="15"
                  >
                    <CircularProgress color="inherit" size={16} />
                  </CustomButton>
                ) : ( */}
                <CustomButton
                  variant="contained"
                  type="submit"
                  sx={{
                    fontSize: 20,
                    height: 50,
                    // width: '100%',
                    // flexGrow: 1,
                    // mt: 1,
                  }}
                >
                  {loader ? (
                    <CircularProgress color="inherit" size={16} />
                  ) : (
                    'Register'
                  )}
                </CustomButton>
                {/* )} */}
              </FormGroup>
              <div className={classes.newRegister}>
                Already have an account?{' '}
                <Link
                  sx={{ textDecoration: 'none' }}
                  // to={
                  //   redirectUrl
                  //     ? {
                  //         pathname: '/login',
                  //         search: `?redirect_url=${encodeURIComponent(
                  //           redirectUrl,
                  //         )}`,
                  //       }
                  //     : { pathname: '/login' }
                  // }
                  href="/login"
                >
                  Login
                </Link>
              </div>
            </form>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default EmailSignup;
